jQuery(document).ready(function ($){    
    $.noConflict();
  function replaceCodes(toReplace, replaceWith) {
    if ($("#order-summary .product__description .reduction-code .reduction-code__text").length > 0) {
      $("#order-summary .product__description .reduction-code .reduction-code__text").each(function() {
        var split = $(this).text().split("(");
        var final = [];
        if ($(this).text().split(" (")[0].toLowerCase().trim() === toReplace.toLowerCase()) {
          final.push(replaceWith);
          final.push(split[1]);
          $(this).text(final.join(" ("));
        }
      });
    }
  if ($("#order-summary .order-summary__section.order-summary__section--discount .edit_checkout .reduction-code__text").length > 0) {
      $("#order-summary .order-summary__section.order-summary__section--discount .edit_checkout .reduction-code__text").each(function() {
        var final = [];
        if ($(this).text().toLowerCase().trim() === toReplace.toLowerCase()) {
          final.push(replaceWith);
          $(this).text(final);
        }
      });
    }
    if ($(".section--reductions .reduction-code__text").length > 0) {
      $(".section--reductions .reduction-code__text").each(function() {
        var final = [];
        if ($(this).text().toLowerCase().trim() === toReplace.toLowerCase()) {
          final.push(replaceWith);
          $(this).text(final);
        }
      });
    }
  } 
  
  replaceCodes("Morbid Patreon Discount", "15% special discount for Morbid fans");
  
  $(document).on("page:load page:change", function(event) {
    console.log(event);
    replaceCodes("Morbid Patreon Discount", "15% special discount for Morbid fans");
    document.querySelectorAll('.product__description .product__description__property').forEach(function(th) {
          th.innerHTML = th.innerHTML.replace('p_message: ', '');
          if (th.textContent.includes("EDD NULL OR VARIANT UNAVAILABLE") || th.textContent.includes("previewImage") || th.textContent.includes("Estimated Ship Date End") || th.textContent.includes("Estimated Delivery Date Begin") || th.textContent.includes("Estimated Delivery Date End")) {th.style.display = "none";};
        });
  });
});